<template>
  <!--  <div :class="isPcFlag ? 'dialog_sueecss_pc' : 'dialog_sueecss_h5'">-->
  <!--    <div class="sueecss_box">-->
  <!--      <div class="dialog-close">-->
  <!--        <i class="el-icon-close" @click="() => this.$emit('closeform')"></i>-->
  <!--      </div>-->
  <!--      <div class="tip">-->
  <!--        <img class="sueecss-icon" :src="require('@/assets/images/sueecss-icon.png')" />-->
  <!--        <h4 style="margin-left: 13px">提交成功！</h4>-->
  <!--      </div>-->
  <!--      <div class="title">-->
  <!--        <p>客服人员e小宝将在1个工作日内与您取得联系开通试用哟</p>-->
  <!--      </div>-->
  <!--      <div class="focus">-->
  <!--        <img v-if="$route.path === '/chunsheng'" style="height: 130px; margin-bottom: 9px" src="@/assets/images/chunshengcode.png" />-->
  <!--        <img v-else class="code" :src="require('@/assets/images/code.png')" />-->
  <!--        <p v-if="$route.path === '/chunsheng'">关注服务顾问</p>-->
  <!--        <p v-else>关注专属顾问</p>-->
  <!--        <p v-if="$route.path === '/chunsheng'">了解电子合同发放进度</p>-->
  <!--        <p v-else>获取1份数字化报告</p>-->
  <!--      </div>-->
  <!--    </div>-->
  <!--  </div>-->

  <!--20240407 需求 样式更换-->
  <!-- 独立完成弹窗提示-->
  <div class="dialog-success-pc">
    <div class="success-box">
      <div class="form-box-close">
        <div class="form-box-close-icon" @click="() => this.$emit('closeform')"></div>
      </div>

      <img class="top-icon" src="https://www.esign.cn/upload/resources/image/2024/03/06/42005.png" alt="勾选icon" />

      <p class="line1">恭喜你，开通试用成功</p>
      <p class="line2">电子合同、电子签章扫码开始试用</p>
      <!--二维码-->
      <div class="form-main">
        <div class="qr-container">
          <img class="qr" src="https://www.esign.cn/upload/resources/image/2024/04/09/43148.png" alt="联系二维码" />
        </div>

        <div style="display:flex;">
          <img class="wx" src="https://www.esign.cn/upload/resources/image/2024/03/06/42015.png" alt="微信icon" />
          <span class="bottom-text">微信扫一扫</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isPcFlag: Boolean, // 是Pc还是H5
  },
}
</script>

<style lang="less" scoped>
//// pc样式
//.dialog_sueecss_pc {
//  position: fixed;
//  left: 0;
//  right: 0;
//  top: 0;
//  bottom: 0;
//  z-index: 10000;
//  background-color: rgba(0, 0, 0, 0.45);
//  z-index: 999999;
//  .dialog-close {
//    width: 100px;
//    height: 100px;
//    background: url('../assets/images/trial_dialog_close_bg.png') top right / cover no-repeat;
//    position: absolute;
//    top: 0;
//    right: 0;
//  }
//
//  .sueecss_box {
//    position: relative;
//    display: flex;
//    flex-direction: column;
//    align-items: center;
//    width: 460px;
//    height: 500px;
//    padding: 0 50px;
//    font-size: 14px;
//    box-shadow: 6px 6px 13px 10px rgba(2, 6, 11, 0.23);
//    background: #fff;
//    color: #666b80;
//    transform: translate(-50%, -50%);
//    left: 50%;
//    top: 50%;
//    i {
//      position: absolute;
//      top: 12px;
//      right: 14px;
//      font-size: 24px;
//      cursor: pointer;
//    }
//    .tip {
//      display: flex;
//      flex-direction: column;
//      align-items: center;
//      margin-top: 80px;
//      .sueecss-icon {
//        width: 60px;
//        height: 60px;
//        margin-bottom: 12px;
//      }
//      h4 {
//        font-size: 18px;
//        color: #32373f;
//        font-weight: 700;
//        font-family: PingFangSC-Medium, PingFang SC;
//      }
//    }
//    .title {
//      width: 100%;
//      margin-top: 18px;
//      text-align: center;
//    }
//    .focus {
//      margin-top: 36px;
//      margin-bottom: 70px;
//      text-align: center;
//      .code {
//        width: 130px;
//        height: 130px;
//        margin-bottom: 9px;
//      }
//    }
//  }
//}
//// h5样式
//.dialog_sueecss_h5 {
//  position: fixed;
//  left: 0;
//  right: 0;
//  top: 0;
//  bottom: 0;
//  z-index: 10000;
//  background-color: rgba(0, 0, 0, 0.45);
//  z-index: 999999;
//  .dialog-close {
//    width: 2.1333rem;
//    height: 2.1333rem;
//    background: url('../assets/images/trial_dialog_close_bg.png') top right / cover no-repeat;
//    position: absolute;
//    top: 0;
//    right: 0;
//  }
//
//  .sueecss_box {
//    position: relative;
//    display: flex;
//    flex-direction: column;
//    align-items: center;
//    width: 90%;
//    height: 60%;
//    padding: 0 1.3333rem;
//    font-size: 0.3733rem;
//    box-shadow: 0.16rem 0.16rem 0.3467rem 0.2667rem rgba(2, 6, 11, 0.23);
//    background: #fff;
//    color: #666b80;
//    transform: translate(-50%, -50%);
//    left: 50%;
//    top: 50%;
//    i {
//      position: absolute;
//      top: 0.32rem;
//      right: 0.2667rem;
//      font-size: 0.64rem;
//      cursor: pointer;
//    }
//    .tip {
//      display: flex;
//      flex-direction: column;
//      align-items: center;
//      margin-top: 0.8rem;
//      .sueecss-icon {
//        width: 1.0667rem;
//        height: 1.0667rem;
//        margin-bottom: 0.32rem;
//      }
//      h4 {
//        font-size: 0.48rem;
//        color: #32373f;
//        font-weight: 700;
//        font-family: PingFangSC-Medium, PingFang SC;
//      }
//    }
//    .title {
//      width: 100%;
//      margin-top: 0.48rem;
//      text-align: center;
//    }
//    .focus {
//      margin-top: 0.8rem;
//      margin-bottom: 0.8rem;
//      text-align: center;
//      .code {
//        width: 3.4667rem;
//        height: 3.4667rem;
//        margin-bottom: 0.24rem;
//      }
//    }
//  }
//}

.dialog-success-pc {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.45);
  z-index: 999999;
  .success-box {
    box-sizing: border-box;
    width: 460px;
    height: 470px;
    //max-width: 90%;
    //min-height: 500px;
    padding: 36px 50px;
    background: url('https://www.esign.cn/upload/resources/image/2024/03/06/42004.png') no-repeat center;
    background-size: cover;
    box-shadow: 0 4px 16px 0 rgba(8, 30, 80, 0.1);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    .form-box-close {
      width: 100px;
      height: 100px;
      cursor: pointer;
      position: absolute;
      top: 0;
      right: 0;
      .form-box-close-icon {
        width: 26px;
        height: 26px;
        margin: 10px 10px 0 0;
        background: url(https://www.esign.cn/images/trialDialog/icon-close.png);
        background-size: 100%;
        font-size: 28px;
        line-height: 14px;
        float: right;
        color: #999;
        cursor: pointer;
        transform: rotate(0deg);
        transition: all 0.4s ease-in-out;
        &:hover {
          transform: rotate(90deg);
        }
      }
    }

    .top-icon {
      width: 35px;
      height: 35px;
      margin: 11px 0;
    }

    .line1 {
      width: 220px;
      height: 30px;
      overflow-wrap: break-word;
      color: rgba(0, 0, 0, 0.85);
      font-size: 22px;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      text-align: justify;
      white-space: nowrap;
      line-height: 30px;
      margin-left: 10px;
    }

    .line2 {
      width: 240px;
      height: 22px;
      overflow-wrap: break-word;
      color: rgba(0, 0, 0, 0.65);
      font-size: 16px;
      font-weight: normal;
      text-align: justify;
      white-space: nowrap;
      line-height: 22px;
      margin-top: 11px;
    }

    .form-main {
      box-shadow: 0 2px 7px 0 rgba(225, 229, 237, 0.83);
      background-color: rgba(255, 255, 255, 1);
      border-radius: 16px;
      width: 198px;
      height: 211px;
      border: 1px solid rgba(255, 255, 255, 1);
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      margin-top: 11px;
      padding-bottom: 4px;
    }

    .qr-container {
      width: 198px;
      height: 211px;
      justify-content: center;
      .qr {
        width: 164px;
        height: 164px;
        margin: 11px 0 0 17px;
      }
    }

    .wx {
      width: 13px;
      height: 11px;
      margin-top: 5px;
    }

    .bottom-text {
      width: 70px;
      height: 20px;
      overflow-wrap: break-word;
      color: rgba(0, 0, 0, 0.85);
      font-size: 14px;
      font-weight: normal;
      text-align: justify;
      white-space: nowrap;
      line-height: 20px;
      padding-left: 6px;
    }
  }
}
</style>
